import React from "react";
import PdfBase from "./PdfBase";
import { generateDonationPdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  donationRows,
  totalDonation,
  additionDeduction,
  additionDeductionAmount,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    donationRows,
    totalDonation,
    additionDeduction,
    additionDeductionAmount,
    notes,
    reviewNotes,
  ];

  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) => generateDonationPdf(forView, ...sharedArgs)}
        downloadName='Donation Schedule'
      />

      <ExcelBase
        generateExcel={(forView) =>
          generateDonationPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
